/*
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);
